module.exports = __webpack_public_path__ + "img/logo.d35c4eeb.png";